import axios from 'axios';

import { SET_USER_INFORMATION, RESET_INVESTOR } from '../constant';

import { resetAdviserInvite } from './Adviser';

export const getAddress = (value) => {
  return () => {
    return axios
      .get(`investor/get-uk-address`, { params: { input: value } })
      .then((response) => {
        if (response.status === 200) {
          return Promise.resolve(response);
        }
      })
      .catch((error) => {
        return Promise.resolve({ error: error?.response?.data?.responseMsg });
      });
  };
};

export const logout = ({ queryClient }) => {
  return (dispatch) => {
    return axios
      .post(`further-user/logout`)
      .then((response) => {
        if (response.status === 200) {
          const utmSource = localStorage.getItem('utm_source');
          localStorage.clear();
          if (utmSource) {
            localStorage.setItem('utm_source', utmSource);
          }

          dispatch({
            type: RESET_INVESTOR,
          });
          dispatch(userInformation(null));
          dispatch(resetAdviserInvite());
          if (queryClient) {
            queryClient.clear();
          }
          return Promise.resolve(response);
        }
      })
      .catch((error) => {
        return Promise.resolve({ error: error.response?.data?.responseMsg });
      });
  };
};

export const userInformation = (value) => {
  return (dispatch) => {
    dispatch({
      type: SET_USER_INFORMATION,
      payload: value,
    });
  };
};

export const getQuestionarries = () => {
  return () => {
    return axios
      .get(`investor/question-list`)
      .then((response) => {
        if (response.status === 200) {
          return Promise.resolve(response);
        }
      })
      .catch((error) => {
        return Promise.resolve({ error: error?.response?.data?.responseMsg });
      });
  };
};

export const completeInvestment = (abandonmentId, onSuccess) => {
  return () => {
    return axios
      .get(`user/complete-investment/${abandonmentId}`)
      .then((response) => {
        if (response.status === 200) {
          onSuccess?.();
          return Promise.resolve(response);
        }
      })
      .catch((error) => {
        return Promise.resolve({ error: error?.response?.data?.responseMsg });
      });
  };
};

export const submitWithdrawalRequest = (body, investorId) => {
  return () => {
    return axios
      .post(`investor/withdrawal-request?investorId=${investorId}`, body)
      .then((response) => {
        if (response.status === 200) {
          return Promise.resolve(response);
        }
      })
      .catch((error) => {
        return Promise.reject(error?.response?.data?.responseMsg);
      });
  };
};
